<template>
	<router-view :key="$route.fullPath"></router-view>
</template>
<script>
import { ActivityActions } from '../../store/actions';
export default {
	name: 'GridsPage',
	destroyed() {
		this.$store.dispatch(ActivityActions.CLEAR);
	},
};
</script>
